<template>
    <div>
        <div class="zhanj">
            <div class="hd">
            <div class="name">近30场战绩</div>
            <div class="slc">
                <span class="sc" title="胜">{{ data.sheng }}</span>
                <span class="pi" title="平">{{ data.ping }}</span>
                <span class="sh" title="负">{{ data.shu }}</span>
<!--                <span class="sl">胜率</span>-->
<!--                <span class="sp">{{ data.sl }}%</span>-->
            </div>
            </div>
            <div class="con">
                <router-link :to="url">
                    <van-tabs>
                        <van-tab v-for="(c, i) in data.list" :key="i" :title="c.name" :title-class="'van-tab-rs'+ c.id"/>
                    </van-tabs>
<!--                    <span v-for="(c, index) in data.list" :key="index" :class="'rs'+ c.id">{{ c.name }}</span>-->
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "match_dan_his",
    props: ['data', 'url'],
    components: {
    },
    watch: {

    },
    data(){
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped>
</style>
